export default __webpack_public_path__ + "static/media/feature-icon-03.9687ca36.svg";